export default "__VITE_ASSET__DH61J$R___"